import type { WikiRebuildResult } from '../api/coworkApi';

/** Pages built from the Brand OS that go (deleted or written over), and the fresh pages that take their place. */
export function rebuildCounts(r: WikiRebuildResult): { replaced: number; fresh: number } {
  return { replaced: r.removed + r.overwritten, fresh: r.created + r.overwritten };
}
